import React, { useEffect, useState, useRef } from 'react';
import { toast } from 'react-toastify';
import { addLead, getCurrentOpenLead, updateLead } from '../services/telecalling';
import Breadcrumbs from '../components/BreadCrumbs';
import 'chart.js/auto';
import TelecallingViewDetails from './TelecallingViewDetails';
import CustomLoading from '../components/customLoading/CustomLoading';
import { getUserId } from '../helpers/local_storage_helpers';
import Button from '../components/buttons/Button';
import { MdAdd } from 'react-icons/md';
import ShowModal from '../utils/ShowModal';
import AddLeadForm from './AddLeadForm';


function TelecallingActiveView() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchData = async ({ needLoading = true }) => {
        if (needLoading) {
            setLoading(true);
        }
        try {
            let res = await getCurrentOpenLead();
            if (res.status === 200) {
                setData(res.data);
            } else if (res.status === 404) {
                setData(null);
                toast.error(res.data.error);
            }
        } catch (error) {
            console.error("Error fetching leads:", error);
            toast.error("Error fetching leads data.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData({ needLoading: true });
        const timeout = setInterval(() => {
            fetchData({ needLoading: false });
        }, 8000);

        return () => clearTimeout(timeout);
    }, []);

    const handleStatusChange = async (leadId, newStatus) => {
        try {
            let res = await updateLead(leadId, newStatus);
            if (res.status === 200) {
                toast.success("Lead status updated");
                fetchData();
            } else {
                toast.error("Failed to update lead status");
            }
        } catch (error) {
            console.error("Error updating lead status:", error);
            toast.error("Error updating lead status");
        }
    };

    return (
        <div className="space-y-4">
            <Breadcrumbs items={[
                { name: 'Dashboard', link: '/dashboard' },
                { name: 'Telecalling Active View' },
            ]} />

            {/* Leads List */}
            <div className="bg-white rounded-lg shadow p-4">
                {
                    loading ? <CustomLoading /> :
                        data ? (
                            <TelecallingViewDetails
                                lead={data}
                                onStatusChange={(newStatus) => {
                                    handleStatusChange(data.id, newStatus);
                                }}
                            />
                        ) : (
                            <div className="flex flex-col items-center justify-center py-8 bg-blue-50 rounded-lg">
                                <div className="text-primary mb-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                                <h3 className="text-md font-medium text-gray-700 mb-1">No lead active</h3>
                                <p className="text-sm text-gray-500 mb-4">Try making a phone call via app to active a lead</p>
                            </div>
                        )
                }
            </div>
        </div>
    );
}

export default TelecallingActiveView;